import { Bell } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function Benefits() {
  const { t } = useTranslation();

  return (
    <section className="px-6 py-20">
      <div className="max-w-3xl mx-auto space-y-12">
        <h2 className="text-4xl font-light tracking-tight">{t('benefits.title')}</h2>

        <div className="grid gap-8">
          <div className="border-l-2 border-gray-900 pl-6 py-4">
            <h3 className="text-lg font-semibold mb-2">{t('benefits.benefit_1_title')}</h3>
            <p className="text-gray-600 font-light">{t('benefits.benefit_1_text')}</p>
          </div>

          <div className="border-l-2 border-gray-900 pl-6 py-4">
            <h3 className="text-lg font-semibold mb-2">{t('benefits.benefit_2_title')}</h3>
            <p className="text-gray-600 font-light">{t('benefits.benefit_2_text')}</p>
          </div>

          <div className="border-l-2 border-gray-900 pl-6 py-4">
            <h3 className="text-lg font-semibold mb-2 flex items-center gap-2">
              <Bell size={18} />
              {t('benefits.benefit_3_title')}
            </h3>
            <p className="text-gray-600 font-light">{t('benefits.benefit_3_text')}</p>
          </div>
        </div>
      </div>
    </section>
  );
}